import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/modifierItems_initialState.ts
var MODIFIER_ITEM_PRICING_VERSION_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationModifierItemPricingVersionId: 0,
  modifierItemPricingVersionId: 0,
  createdByLocationId: 0,
  locationId: 0,
  name: "Default",
  organizationId: 0,
  modifierItemId: 0,
  includedMasterPrice: 0,
  additionalMasterPrice: 0,
  quarterPricePercent: 100,
  halfPricePercent: 100,
  includedLightPrice: 0,
  includedRegularPrice: 0,
  includedExtraPrice: 0,
  additionalLightPrice: 0,
  additionalRegularPrice: 0,
  additionalExtraPrice: 0,
  locationModifierItemPricingVersionVersionId: 0,
  onSidePrice: 0
});
var MODIFIER_ITEM_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationModifierItemId: 0,
  modifierItemId: 0,
  locationId: 0,
  createdByLocationId: 0,
  organizationId: 0,
  posName: "",
  kdsName: "",
  checkName: "",
  active: true,
  description: "",
  defaultModifierItemPricingVersionId: 0,
  defaultQuantitySelected: 0,
  parentModifierGroupIds: [],
  defaultAmountSelected: "Regular",
  modifierItemPricingVersions: {
    0: MODIFIER_ITEM_PRICING_VERSION_INITIAL_STATE
  },
  name: "",
  modifierGroups: {},
  onlineName: "",
  locationModifierItemVersionId: 0,
  defaultModifiersPrice: 0,
  is86ed: false,
  linkedItemId: null,
  removeItemTaxExempt: false,
  prepStationIds: []
});

export { MODIFIER_ITEM_INITIAL_STATE, MODIFIER_ITEM_PRICING_VERSION_INITIAL_STATE };
